"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LittlewoodsRound", {
  enumerable: true,
  get: function get() {
    return _LittlewoodsRound["default"];
  }
});
Object.defineProperty(exports, "LittlewoodsRoundBasic", {
  enumerable: true,
  get: function get() {
    return _LittlewoodsRoundBasic["default"];
  }
});
Object.defineProperty(exports, "LittlewoodsRoundWhite", {
  enumerable: true,
  get: function get() {
    return _LittlewoodsRoundWhite["default"];
  }
});
Object.defineProperty(exports, "LittlewoodsStrip", {
  enumerable: true,
  get: function get() {
    return _LittlewoodsStrip["default"];
  }
});
Object.defineProperty(exports, "LittlewoodsStripWhite", {
  enumerable: true,
  get: function get() {
    return _LittlewoodsStripWhite["default"];
  }
});
Object.defineProperty(exports, "ParcelconnectRed", {
  enumerable: true,
  get: function get() {
    return _ParcelconnectRed["default"];
  }
});
Object.defineProperty(exports, "ParcelconnectWhite", {
  enumerable: true,
  get: function get() {
    return _ParcelconnectWhite["default"];
  }
});
Object.defineProperty(exports, "TakeThree", {
  enumerable: true,
  get: function get() {
    return _TakeThree["default"];
  }
});
Object.defineProperty(exports, "TakeThreeStacked", {
  enumerable: true,
  get: function get() {
    return _TakeThreeStacked["default"];
  }
});
Object.defineProperty(exports, "TakeThreeWhite", {
  enumerable: true,
  get: function get() {
    return _TakeThreeWhite["default"];
  }
});
Object.defineProperty(exports, "VeryPay", {
  enumerable: true,
  get: function get() {
    return _VeryPay["default"];
  }
});
Object.defineProperty(exports, "VeryPayBoxPinkV1", {
  enumerable: true,
  get: function get() {
    return _VeryPayBoxPinkV["default"];
  }
});
Object.defineProperty(exports, "VeryPayBoxWhiteV1", {
  enumerable: true,
  get: function get() {
    return _VeryPayBoxWhiteV["default"];
  }
});
Object.defineProperty(exports, "VeryPayWhite", {
  enumerable: true,
  get: function get() {
    return _VeryPayWhite["default"];
  }
});
Object.defineProperty(exports, "VeryPrimary", {
  enumerable: true,
  get: function get() {
    return _VeryPrimary["default"];
  }
});
var _LittlewoodsRound = _interopRequireDefault(require("./LittlewoodsRound.svg"));
var _LittlewoodsRoundBasic = _interopRequireDefault(require("./LittlewoodsRoundBasic.svg"));
var _LittlewoodsRoundWhite = _interopRequireDefault(require("./LittlewoodsRoundWhite.svg"));
var _LittlewoodsStrip = _interopRequireDefault(require("./LittlewoodsStrip.svg"));
var _LittlewoodsStripWhite = _interopRequireDefault(require("./LittlewoodsStripWhite.svg"));
var _ParcelconnectRed = _interopRequireDefault(require("./ParcelconnectRed.svg"));
var _ParcelconnectWhite = _interopRequireDefault(require("./ParcelconnectWhite.svg"));
var _TakeThree = _interopRequireDefault(require("./TakeThree.svg"));
var _TakeThreeStacked = _interopRequireDefault(require("./TakeThreeStacked.svg"));
var _TakeThreeWhite = _interopRequireDefault(require("./TakeThreeWhite.svg"));
var _VeryPay = _interopRequireDefault(require("./VeryPay.svg"));
var _VeryPayBoxPinkV = _interopRequireDefault(require("./VeryPayBoxPinkV1.svg"));
var _VeryPayBoxWhiteV = _interopRequireDefault(require("./VeryPayBoxWhiteV1.svg"));
var _VeryPayWhite = _interopRequireDefault(require("./VeryPayWhite.svg"));
var _VeryPrimary = _interopRequireDefault(require("./VeryPrimary.svg"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}